import { View } from "binder"
import { StringEditorViewModel } from "./stringEditor-viewModel"

export class StringEditorView extends View<StringEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-E106D32A-61EA-46BE-B171-DF953963765A"
    }
    loadHtml(): string {
        let element = require('./stringEditor.html').default;
        let style = require('./stringEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    
}
